export default "__VITE_ASSET__HDzRspLH__"